import MuiTooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material';
import Zoom from '@mui/material/Zoom';

interface ExtendedTooltipProps extends TooltipProps {
  monospaceTooltip?: boolean;
}

export const Tooltip = styled(({ className, ...props }: ExtendedTooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} TransitionComponent={Zoom} />
))(({ theme, monospaceTooltip }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    border: `1px solid ${theme.color.line.standard}`,
    fontSize: '1.5ch',
    maxWidth: 'none',
    whiteSpace: 'pre-wrap',
    fontFamily: monospaceTooltip ? 'monospace' : 'Inter',
  },
}));
